<template>
  <div class="grid-y grid-frame login__container">
    <div class="cell auto ">
      <div class="grid-x full-height" v-if="interface_settings">
        <div class="cell medium-7 full-height login__bg" :style="background">
          <div class="login__left align-self-bottom">
            <div class="login__title">
              {{ interface_settings.login_screen_title }}
            </div>
            <div class="login__subtitle">
              {{ interface_settings.login_screen_subtitle }}
            </div>
          </div>
        </div>
        <div class="cell medium-5 align-self-middle login__right">
          <div class="login__form-container">
            <div class="login__client-logo" v-if="interface_settings">
              <img :src="logo" alt=""/>
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
  data () {
    return {
      interface_settings: null
    }
  },
  created () {
    this.interface_settings = this.$store.state.interface_settings
  },
  computed: {
    logo () {
      if (
        this.interface_settings.login_screen_logo &&
        this.interface_settings.login_screen_logo.image
      ) {
        return this.interface_settings.login_screen_logo.image.filepath
      }
      return 'https://abrnd.abrnd.com/storage/app/media/Merk/Logo/Beeldmerk%20-%20Zwart.svg'
    },
    background () {
      if (
        this.interface_settings.login_screen_bg_type === 'image' &&
        this.interface_settings.login_screen_bg_image.image
      ) {
        return (
          'background-image:url(\'' +
          this.interface_settings.login_screen_bg_image.image.filepath +
          '\');'
        )
      } else {
        return (
          'background-color:#' +
          this.interface_settings.login_screen_bg_color +
          ';'
        )
      }
    }
  }
}
</script>
